const waitForElement = (selector: string): Promise<HTMLElement> =>
    new Promise(resolve => {
        const observer = new MutationObserver(() => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector) as HTMLElement);
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    });

export { waitForElement };
